import { createStore } from 'vuex'
import about from './modules/about'
import auth from './modules/auth'
import banner from './modules/banner'
import career from './modules/career'
import catalog from './modules/catalog'
import category from './modules/category'
import contact from './modules/contact'
import footer from './modules/footer'
import our_certificate from './modules/our-certificate'
import our_client from './modules/our-client'
import our_specialist from './modules/our-specialist'
import our_team from './modules/our-team'
import product from './modules/product'
import project from './modules/project'
import user_management from './modules/user-management'
import vision_mission from './modules/vision-mission'
import why_edim from './modules/why-edim'

const store = createStore({
	modules: {
		ABOUT: about,
		AUTH: auth,
		BANNER: banner,
		CAREER: career,
		CATALOG: catalog,
		CATEGORY: category,
		CONTACT: contact,
		FOOTER: footer,
		OUR_CERTIFICATE: our_certificate,
		OUR_CLIENT: our_client,
		OUR_TEAM: our_team,
		PRODUCT: product,
		PROJECT: project,
		SPECIALIST: our_specialist,
		USER_MANAGEMENT: user_management,
		VISION_MISSION: vision_mission,
		WHY_EDIM: why_edim,
	},
})

export default store
